import LocalizedStrings from 'react-localization';

export const productExplorerStrings = new LocalizedStrings({
  en: {
    searchPlaceholder: 'Search for computers, devices or accessories',
    noCategories: 'No categories',
    manageFilters: 'Manage visibility & margin filters',
    bulkUploadProducts: 'Bulk manage products',
    addNewProduct: 'Add new product',
    createCategory: 'Create category',
    createManufacturer: 'Create manufacturer',
    createBundle: 'Create bundle',
    editProductInfo: 'Edit product information',
    seeProductInfo: 'See product information',
    setProductMargin: 'Set product margin',
    category: 'Category',
    unapprovedPrices: 'Show unapproved prices',
    approvedPrices: 'Show approved prices'
  }
});
